import { ReactToExerciseEventType, StartExercise, UpdateObjective } from "Phaser/EventBus";
import Tutorial, { ChapterType, ExerciseScene } from "Types/ExerciseData";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level5.json";
import { Event, Exercise, Lecture, PianoScene, Section } from "Utils/TutorialConfigHelper"

// This is still using the old JSON way of defining levels
const Level5: Tutorial = {
  end: '2:22',
  level: 5,
  videoUrl: 'level-5.mp4',
  sections: [
    {
      chapters: [
        {
          title: 'A in the Bass Clef',
          start: '0:0',
          data: [ChapterType.Lecture]
        },
        {
          title: 'A on the Keyboard',
          start: '0:12',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Find A',
          start: '0:25',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.PianoScene,
                {
                  start: 'A0',
                  end: 'C8',
                  transition: 'Dissolve',
                  textPromptPosition: 'Top',
                  objectives: [
                    {
                      text: 'Play A on your keyboard.',
                      target: 'A3',
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
      ]
    },
    {
      chapters: [
        {
          title: 'Playing with the 3rd Finger',
          start: '0:36',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Playing A',
          start: '0:36',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: false,
                  padding_x: 700,
                  objectives: [
                    {
                      text: 'Play these notes at your own pace.',
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: 'Using the First 3 Fingers',
          start: '0:44',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Alternating Fingers',
          start: '1:04',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: true,
                  padding_x: 700,
                  objectives: [
                    {
                    },
                    {
                    },
                    {
                    }
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: 'Playing in Time',
          start: '1:25',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  firstObjectiveAppearDelay: 500,
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
      ]
    },
    {
      chapters: [
        {
          title: 'Using Both Hands',
          start: '1:38',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Playing in Time',
          start: '2:07',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  firstObjectiveAppearDelay: 500,
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        }
      ]
    }
  ]
};

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level5);
